import { render, staticRenderFns } from "./column-field.vue?vue&type=template&id=1b6ea2da&"
import script from "./column-field.vue?vue&type=script&lang=js&"
export * from "./column-field.vue?vue&type=script&lang=js&"
import style0 from "./column-field.vue?vue&type=style&index=0&id=1b6ea2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports